<template>
  <div id="app" class="wrapper">
    <main class="page-body">
      <router-view />
    </main>
    <Footer
      :class="isTransparent ? 'bg-none' : 'bg-white shadow'"
      class="page-footer mt-5"
    />
  </div>
</template>

<script>
import { Footer } from "@/components";
/**
 * @description La page à partir de laquelle toutes les autres s'affichent
 * @author Alexandre Gallant
 * @author Francine Jin
 * @vue-computed {Boolean} isTransparent - Si le footer de la page actuelle doit être transparent
 */
export default {
  name: "App",
  components: {
    Footer
  },
  computed: {
    isTransparent() {
      const transparentRoutes = ["404", "login", "home"];
      return transparentRoutes.includes(this.$route.name);
    }
  }
};
</script>
<style scoped>
.wrapper {
  min-height: 100%;
  display: grid;
  grid-template-rows: 1fr auto;
}
</style>
